import { cn } from '@/lib/cn';
import { deltaPercent } from '@/lib/miniprogramAnalyticsShared';

export function AnalyticsDeltaBadge({
  today,
  yesterday,
  compact,
}: {
  today: number;
  yesterday: number;
  compact?: boolean;
}) {
  const pct = deltaPercent(today, yesterday);
  if (pct === null) {
    return <span className="text-xs font-medium text-slate-400">较昨日 —</span>;
  }
  const up = pct >= 0;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-0.5 rounded-full font-semibold',
        compact ? 'px-1.5 py-0 text-[10px]' : 'px-2 py-0.5 text-xs',
        up ? 'bg-emerald-50 text-emerald-700' : 'bg-rose-50 text-rose-700'
      )}
    >
      <i className={cn('fa-solid', up ? 'fa-arrow-trend-up' : 'fa-arrow-trend-down', compact ? 'text-[8px]' : 'text-[10px]')} aria-hidden />
      {up ? '+' : ''}
      {pct}%
      {!compact ? <span className="font-normal text-slate-500">较昨日</span> : null}
    </span>
  );
}
